<template>
  <div class="main-wrapper" v-if="items">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click.prevent="btnAddClick">新建服务器</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="items" style="width: 100%">
      <el-table-column label="服务器ID/名称" width="220">
        <template #default="scope">
          <el-link type="primary" style="margin-right: 10px" :underline="false" href="javascript:;">
            {{ scope.row.instanceId }}
          </el-link>
          <br />
          {{ scope.row.nodeName }}
        </template>
      </el-table-column>
      <el-table-column label="服务器类型" width="100">
        <template #default="scope">
          {{ scope.row.isReserves ? '预备役' : '现役' }}
        </template>
      </el-table-column>
      <el-table-column label="服务器位置" width="100">
        <template #default="scope">
          {{ scope.row.isHongKong ? '香港' : '大陆' }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template #default="scope">
          <el-link :type="scope.row.isEnabled ? 'success' : 'danger'" :underline="false" href="javascript:;">
            {{ scope.row.isEnabled ? '运行中' : '待启用' }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="IP地址" width="140">
        <template #default="scope">
          {{ scope.row.ipAddress }}
        </template>
      </el-table-column>
      <el-table-column label="Image 版本" width="180">
        <template #default="scope">
          {{ scope.row.dockerImageVersion }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="140" align="center">
        <template #default="scope">
          {{ scope.row.createdDate }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template #default="scope">
          <div class="actions">
            <el-link type="primary" :underline="false" @click.prevent="btnShellClick(scope.row)">Shell</el-link>
            <el-link type="primary" :underline="false" @click.prevent="btnAssistantClick(scope.row)">云助手</el-link>
            <el-link
              type="primary"
              :underline="false"
              @click.prevent="btnCertClick(scope.row)"
            >
              更新证书
            </el-link>
            <el-link type="primary" :underline="false" @click.prevent="btnEditClick(scope.row)">编 辑</el-link>
            <el-link type="primary" :underline="false" @click.prevent="btnUpdateImageClick(scope.row)">
              更新Image
            </el-link>
            <el-link type="danger" :underline="false" @click.prevent="btnReloadClick(scope.row)">
              重启所有实例
            </el-link>
            <el-link type="danger" :underline="false" @click.prevent="btnRebootClick(scope.row)">重启服务器</el-link>
            <el-link type="danger" :underline="false" @click.prevent="btnDeleteClick(scope.row)">删 除</el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer :title="node.id === 0 ? '新建服务器' : '编辑服务器'" direction="rtl" size="60%" v-model="isFormAdd" @opened="formReset">
      <el-form style="margin: 0 30px" ref="form" :model="node" label-position="top">
        <el-form-item label="服务器Id" prop="instanceId" :rules="{ required: true, message: '请输入服务器Id' }">
          <el-input v-model="node.instanceId" placeholder="服务器Id"></el-input>
        </el-form-item>
        <el-form-item
          v-if="node.id > 0"
          label="服务器名称"
          prop="nodeName"
          :rules="{ required: true, message: '请输入服务器名称' }"
        >
          <el-input v-model="node.nodeName" placeholder="服务器名称"></el-input>
        </el-form-item>
        <el-form-item label="服务器类型" prop="isReserves" :rules="{ required: true, message: '请选择服务器类型' }">
          <el-radio-group v-model="node.isReserves">
            <el-radio :label="false">现役</el-radio>
            <el-radio :label="true">预备役</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务器位置" prop="isHongKong" :rules="{ required: true, message: '请选择服务器位置' }">
          <el-radio-group v-model="node.isHongKong">
            <el-radio :label="false">大陆服务器</el-radio>
            <el-radio :label="true">香港服务器</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务器状态" prop="isEnabled" :rules="{ required: true, message: '请选择服务器状态' }">
          <el-radio-group v-model="node.isEnabled">
            <el-radio :label="false">待启用</el-radio>
            <el-radio :label="true">运行中</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="地域Id" prop="regionId" :rules="{ required: true, message: '请输入地域Id' }">
          <el-input v-model="node.regionId" placeholder="地域Id"></el-input>
        </el-form-item>
        <el-form-item label="IP地址" prop="ipAddress" :rules="{ required: true, message: '请输入IP地址' }">
          <el-input v-model="node.ipAddress" placeholder="IP地址"></el-input>
        </el-form-item>
      </el-form>

      <el-divider></el-divider>

      <div class="el-dialog__footer">
        <el-button type="primary" @click="btnSubmitClick">确 定</el-button>
        <el-button @click="isFormAdd = false">取 消</el-button>
      </div>
    </el-drawer>

    <el-drawer title="服务器Shell" direction="rtl" size="60%" v-model="isShell">
      <el-form style="margin: 0 30px" label-position="top">
        <el-form-item label="Ftp">
          <el-input v-model="shellResult.ftp" :rows="10" type="textarea" />
        </el-form-item>
        <el-form-item label="Docker">
          <el-input v-model="shellResult.docker" :rows="10" type="textarea" />
        </el-form-item>
        <el-form-item label="Nginx">
          <el-input v-model="shellResult.nginx" :rows="10" type="textarea" />
        </el-form-item>
        <el-divider></el-divider>

        <div class="el-dialog__footer">
          <el-button @click="isShell = false">关 闭</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer title="服务器云助手" direction="rtl" size="60%" v-model="isAssistant">
      <el-form style="margin: 0 30px" label-position="top">
        <el-form-item v-if="assistantForm.results" label="结果">
          <el-input v-model="assistantForm.results" :rows="20" type="textarea" />
        </el-form-item>
        <el-form-item label="命令">
          <el-input v-model="assistantForm.command" :rows="5" type="textarea" />
        </el-form-item>
        <el-divider></el-divider>

        <div class="el-dialog__footer">
          <el-button type="primary" @click="btnAssistantSubmitClick">确 定</el-button>
          <el-button @click="isAssistant = false">取 消</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-dialog title="更新Image" v-model="isUpdateImage" width="40%">
      <el-form style="margin: 0 10px" ref="updateImageForm" :model="updateImageForm" label-position="left" label-width="120px">
        <el-form-item label="版本号" prop="version" :rules="{ required: true, message: '请输入版本号' }">
          <el-input v-model="updateImageForm.version" placeholder="请输入版本号"></el-input>
        </el-form-item>
        <el-divider></el-divider>

        <div class="el-dialog__footer">
          <el-button type="primary" @click="btnUpdateImageSubmitClick">确 定</el-button>
          <el-button @click="isUpdateImage = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import utils from '@/utils';
import { defineComponent } from 'vue';
import { INode } from '@/types/models';
import api, { IShellResult } from '@/api/admin/nodes';
import { IElForm } from '@/types/element';

interface IAssistantForm {
  command: string;
  results: string;
}

interface IUpdateImageForm {
  nodeId: number;
  version: string;
}

interface IState {
  items: INode[];
  node: INode;
  isFormAdd: boolean;
  shellResult: IShellResult;
  isShell: boolean;
  isAssistant: boolean;
  assistantForm: IAssistantForm;
  isUpdateImage: boolean;
  updateImageForm: IUpdateImageForm;
}

export default defineComponent({
  data() {
    return {
      items: [],
      node: {
        id: 0,
        isReserves: false,
        nodeName: '',
        ipAddress: '',
      } as INode,
      isFormAdd: false,
      shellResult: {
        nginx: '',
      } as IShellResult,
      isShell: false,
      isAssistant: false,
      assistantForm: {} as IAssistantForm,
      isUpdateImage: false,
      updateImageForm: {} as IUpdateImageForm,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get((res) => {
        this.items = res.items;
      });
    },

    btnShellClick(node: INode) {
      api.shell(node.id, (res) => {
        if (!res) return;
        this.isShell = true;
        this.shellResult = res;
      });
    },

    btnCertClick(node: INode) {
      utils.alertDelete(
        {
          title: '更新节点HTTPS证书',
          text: `此操作将更新 ${node.nodeName} 的节点HTTPS证书，确定吗？`,
          button: '确认更新',
        },
        () => {
          api.updateCert(node.id, (res) => {
            if (!res) return;
            utils.success('节点HTTPS证书更新成功！');
            this.apiGet();
          });
        },
      );
    },

    btnAssistantClick(node: INode) {
      this.node = { ...node };
      this.isAssistant = true;
      this.assistantForm = {
        command: '',
        results: '',
      };
    },

    btnAssistantSubmitClick() {
      this.assistantForm.results = '';
      api.assistant(
        {
          nodeId: this.node.id,
          command: this.assistantForm.command,
        },
        (res) => {
          if (!res) return;
          this.assistantForm.results = res.value;
        },
      );
    },

    btnDeleteClick(node: INode) {
      utils.alertDelete(
        {
          title: '删除服务器',
          text: `此操作将删除服务器${node.nodeName}，确定吗？`,
          button: '确认删除',
        },
        () => {
          api.delete(node.id, (res) => {
            if (!res) return;
            this.apiGet();
            utils.success('服务器删除成功');
          });
        },
      );
    },

    btnRebootClick(node: INode) {
      utils.alertDelete(
        {
          title: '重启服务器',
          text: `此操作将重启服务器${node.nodeName}，确定吗？`,
          button: '确认重启',
        },
        () => {
          api.reboot(node.id, (res) => {
            if (!res) return;
            utils.success('服务器重启成功');
          });
        },
      );
    },

    btnReloadClick(node: INode) {
      utils.alertDelete(
        {
          title: '重启所有实例',
          text: `此操作将重启${node.nodeName}的所有实例，确定吗？`,
          button: '确认重启',
        },
        () => {
          api.reload(node.id, (res) => {
            if (!res) return;
            utils.success('所有实例重启成功');
          });
        },
      );
    },

    formReset() {
      const form = this.$refs.form as IElForm;
      form.clearValidate();
    },

    btnAddClick() {
      this.node = {
        id: 0,
        isReserves: false,
        isHongKong: false,
        isEnabled: false,
        nodeName: '',
        ipAddress: '',
        instanceId: '',
        regionId: 'cn-beijing',
      } as INode;
      this.isFormAdd = true;
    },

    btnEditClick(node: INode) {
      this.node = { ...node };
      this.isFormAdd = true;
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          api.submit(this.node, (res) => {
            if (!res) return;
            this.isFormAdd = false;
            this.apiGet();
            utils.success(`服务器${this.node.id === 0 ? '添加' : '修改'}成功`);
          });
        }
      });
    },

    btnUpdateImageClick(node: INode) {
      this.updateImageForm.nodeId = node.id;
      this.updateImageForm.version = '';
      this.isUpdateImage = true;
    },

    btnUpdateImageSubmitClick() {
      (this.$refs.updateImageForm as IElForm).validate((valid) => {
        if (valid) {
          api.updateImage(this.updateImageForm, (res) => {
            if (!res) return;
            this.isUpdateImage = false;
            this.apiGet();
            utils.success('Docker Image 更新成功');
          });
        }
      });
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
